import { Provider } from 'react-redux';
import configStore from 'store/store';

function Redux({ initialReduxState = {}, children }) {
  const store = configStore(initialReduxState);
  return <Provider store={store}>{children}</Provider>;
}

export default Redux;
